export default __webpack_public_path__ + "static/media/bewegungsempfehlung.e473def7.png";